import { useState } from 'react';
import Select, { StylesConfig, ValueType } from 'react-select';
import SearchImg from '@static/images/seo-landing/search.svg';
import { useRouter } from 'next/router';

import { ResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';

import { H1 } from '@r1-frontend/ui-react/components/typography/heading';

import Advantages from './components/Advantages';
import City from './components/city';
import Popup from './components/popup';
import Promo from './components/Promo';
import Services from './components/Services';

import * as ST from './styled';


const ieStyles = () => {
    if (typeof window !== 'undefined' && 'MSStream' in window && (/edge\/(\d+(\.\d+)?)/i).test(navigator.userAgent) !== true) {
        return {
            'placeholder': {
                top: 10,
                position: 'absolute',
                left: 10,
            },
            'input': {
                top: 10,
                position: 'absolute',
            },
            'search': 10,
            'singleValue': {
                marginTop: 5,
                position: 'absolute',
            },
            'clearIndicator': 13,
        };
    } else {
        return {
            'placeholder': {
                position: 'absolute',
                left: 10,
            },
            'input': null,
            'search': 'unset',
            'singleValue': null,
            'clearIndicator': 'unset',
        };
    }
};
// Переопределение стилей для SelectAutocomplite
interface OptionState {
    isFocused: boolean,
}
// @ts-ignore
const customStyles: StylesConfig = {
    option: (state: OptionState) => ({
        padding: 5,
        background: state.isFocused ? '#fff19e' : '#fff',
    }),
    placeholder: () => ieStyles().placeholder,
    input: () => ieStyles().input,
    singleValue: () => ieStyles().input,

    control: (state: OptionState) => ({
        width: '100%',
        position: 'relative',
        top: 7,
        alignItems: 'center',
        alignContent: 'center',
        fontSize: 16,
        backgroundColor: 'hsl(0,0%,98%)',
        borderColor: state.isFocused ? '#fd0' : '#ddd',
        borderRadius: 0,
        borderStyle: 'solid',
        borderWidth: 1,
        display: 'flex',
        cursor: 'text',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: 40,
        outline: '0 !important',
        transition: 'all 100ms',
        boxSizing: 'border-box',
        ':before': {
            position: 'absolute',
            display: 'block',
            right: 10,
            content: "''",
            width: 17,
            height: 17,
            backgroundImage: `url(${SearchImg})`,
            backgroundRepeat: 'no-repeat',
            top: ieStyles().search,
        },
    }),
    dropdownIndicator: () => ({
        display: 'none',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    menu: () => ({
        position: 'absolute',
        display: 'block',
        width: '100%',
        marginTop: 8,
        background: '#fff',
        borderRadius: 0,
    }),
    menuList: () => ({
        maxHeight: 250,
        overflowY: 'auto',
        paddingBottom: 4,
        paddingTop: 4,
        position: 'relative',
        cursor: 'pointer',
    }),
    clearIndicator: () => ({
        position: 'absolute',
        right: 40,
        background: 'rgba(200, 200, 200, 0.8)',
        color: '#fff',
        display: 'flex',
        padding: 2,
        borderRadius: 10,
        transition: 'color 150ms',
        boxSizing: 'border-box',
        top: ieStyles().clearIndicator,
        ':hover': {
            background: 'rgba(200, 200, 200, 1)',
        },
        'svg': {
            width: 10,
            height: 10,
        },
    }),
};
interface ITestGeoIpPage {
    cities: ResponseDto[] | null,
}
const TestGeoApi = ({ cities }: ITestGeoIpPage) => {
    const [selectedOption, setSelectedOption] = useState<ValueType<{ value: string, label: string }, false>>(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [url, setUrl] = useState('');

    const router = useRouter();

    const cityArray = () => {
        if (Array.isArray(cities)) {
            return cities.reduce((acc: { value: string, label: string }[], city) => {
                acc.push({ value: city.domain, label: city.name });
                return acc;
            }, []);
        }
        return [];
    };
    const handleChange = (selectedOption: ValueType<{ value: string, label: string }, false>) => {
        setSelectedOption(selectedOption);
    };
    const noOptionsMessage = () => {
        return <p>К сожалению нас нет в этом городе попробуйте выбрать из <a onClick={togglePopup}>существующего списка</a></p>;
    };
    const menuIsOpenHandler = (inputValue: string) =>{
        setMenuIsOpen(!!inputValue.length);
    };
    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const changeUrl = (url: string) =>{
        setUrl(url);
        togglePopup();
    };

    const onRequestClick = (url: string) =>{
        if (selectedOption) {
            router.push(`https://${selectedOption.value}.dom.ru${router.query?.url ? router.query?.url : ''}`);
        } else {
            setUrl(url);
            togglePopup();
        }
    };
    return (
        <>
            <ST.Container>
                <ST.WrapperSearch>
                    <H1 $color='TextWhite' $withIndent={false}>Провайдер Дом.ру</H1>

                    <Select
                        options={cityArray()}
                        value={selectedOption}
                        onChange={handleChange}
                        onInputChange={inputValue => menuIsOpenHandler(inputValue)}
                        menuIsOpen={menuIsOpen}
                        isClearable={false}
                        placeholder='Укажите ваш населенный пункт'
                        // @ts-ignore
                        noOptionsMessage={noOptionsMessage}
                        selectFocusedOption={false}
                        onMouseDown={null}
                        autoFocus={false}
                        styles={customStyles}
                    />
                    <City togglePopup={togglePopup}/>
                    <ST.ButtonCity onClick={()=>onRequestClick('')}>Перейти к городу</ST.ButtonCity>
                    {showPopup ? <Popup closePopup={togglePopup} url={url}/> : null}
                </ST.WrapperSearch>
            </ST.Container>
            <Services changeUrl={changeUrl} link={selectedOption?.value ? `https://${selectedOption.value}.dom.ru` : ''}/>
            <Advantages request={onRequestClick}/>
            <Promo request={onRequestClick}/>
        </>
    );
};

export default TestGeoApi;
